import CityPageTemplate from "@/pages/city-template/CityPageTemplate";
import { spartaNjConfig } from "./data";

export default function SpartaNJPage() {
  return <CityPageTemplate config={spartaNjConfig} />;
}